// Gegenereerd door scripts/gen-nlsfb.mjs uit nlbe-sfb-2025.json. Niet met de hand wijzigen.

export const NLBE_SFB_VERSION = "NLBE-SfB-2025-concept-2025-03-14";
export const NLBE_SFB_SOURCE = "NLBE-SfB Tabel 1 – Functionele gebouwelementen, conceptversie 14 maart 2025 (Ketenstandaard Bouw en Techniek / Buildwise)";

/** [code, naam] van de hoofdgroepen ("5-"). */
export const GROUPS: readonly (readonly [string, string])[] = [
  ["0-", "Overkoepelende elementen"],
  ["1-", "Funderingen"],
  ["2-", "Primaire elementen"],
  ["3-", "Secundaire elementen"],
  ["4-", "Afwerkingen"],
  ["5-", "Installaties werktuigbouwkundig"],
  ["6-", "Installaties elektrotechnisch"],
  ["7-", "Vaste inrichtingen"],
  ["8-", "Losse inrichtingen"],
  ["9-", "Elementen buiten het gebouw"],
];

/** [code, naam] van de elementen ("56"). */
export const ELEMENTS: readonly (readonly [string, string])[] = [
  ["01", "Overkoepelende objecten"],
  ["09", "Hoger niet genoemde elementen van (0-)"],
  ["11", "Bodemvoorzieningen"],
  ["13", "Vloeren op grondslag"],
  ["16", "Funderingsconstructies"],
  ["17", "Paalfunderingen"],
  ["19", "Hoger niet genoemde elementen van (1-)"],
  ["21", "Buitenwanden"],
  ["22", "Binnenwanden"],
  ["23", "Vloeren"],
  ["24", "Trappen en hellingen"],
  ["27", "Daken"],
  ["28", "Skeletstructuren"],
  ["29", "Hoger niet genoemde elementen van (2-)"],
  ["31", "Buitenwandopeningen"],
  ["32", "Binnenwandopeningen"],
  ["33", "Vloeropeningen"],
  ["34", "Ballustrades en leuningen"],
  ["37", "Dakopeningen"],
  ["39", "Hoger niet genoemde elementen van (3-)"],
  ["41", "Buitenafwerkingen van wanden"],
  ["42", "Binnenafwerkingen van wanden"],
  ["43", "Vloerafwerkingen"],
  ["44", "Trap- en hellingsafwerkingen"],
  ["45", "Plafondafwerkingen"],
  ["47", "Buitenafwerkingen van daken"],
  ["49", "Hoger niet genoemde elementen van (4-)"],
  ["52", "Afvoeren"],
  ["53", "Watertoevoer"],
  ["54", "Gassen- en brandstoftoevoer"],
  ["55", "Werktuigkundige brandveiligheid"],
  ["56", "Verwarming en koeling"],
  ["57", "Luchtbehandeling"],
  ["58", "Meet- en regelinstallaties"],
  ["59", "Hoger niet genoemde elementen van (5-)"],
  ["61", "Centrale elektrotechnische voorzieningen"],
  ["62", "Energievoorzieningen gebruikersaansluitingen"],
  ["63", "Verlichting"],
  ["64", "Communicatie"],
  ["65", "Beveiliging"],
  ["66", "Transport"],
  ["67", "Gebouw managementsystemen"],
  ["69", "Hoger niet genoemde elementen van (6-)"],
  ["71", "Vaste verkeersinrichtingen"],
  ["72", "Vaste gebruikersinrichtingen"],
  ["73", "Vaste keukeninrichtingen"],
  ["74", "Vaste sanitaire inrichtingen"],
  ["75", "Vaste onderhoudsinrichtingen"],
  ["76", "Vaste opslaginrichtingen"],
  ["77", "Vaste functionele inrichtingen"],
  ["78", "Gebouwgebonden kunst"],
  ["79", "Hoger niet genoemde elementen van (7-)"],
  ["81", "Losse verkeersinrichtingen"],
  ["82", "Losse gebruikersinrichtingen"],
  ["83", "Losse keukeninrichtingen"],
  ["84", "Losse sanitaire inrichtingen"],
  ["85", "Losse schoonmaakinrichtingen"],
  ["86", "Losse opslaginrichtingen"],
  ["87", "Losse functionele inrichtingen"],
  ["88", "Kunst"],
  ["89", "Hoger niet genoemde elementen van (8-)"],
  ["91", "Bodemvoorzieningen buiten gebouw"],
  ["92", "Constructies buiten gebouw"],
  ["93", "Afsluitingen buiten gebouw"],
  ["94", "Afwerkingen bodem buiten gebouw"],
  ["95", "Installaties werktuigbouwkundig buiten gebouw"],
  ["96", "Installaties elektrotechnisch buiten gebouw"],
  ["97", "Vaste inrichtingen buiten gebouw"],
  ["98", "Losse inrichtingen buiten gebouw"],
  ["99", "Elementen van tabel 1 hoger niet genoemd in (0-) t/m (98)"],
];

/** [code, naam] van subelementen ("56.2") en detailcodes ("56.21"). */
export const SUBS: readonly (readonly [string, string])[] = [
  ["01.0", "containerelementen"],
  ["01.1", "objecten t.b.v. ondersteuning bouwproces"],
  ["01.10", "objecten t.b.v. ondersteuning bouwproces, algemeen (verzamelniveau)"],
  ["01.12", "objecten t.b.v. ondersteuning bouwproces, tijdelijke accommodaties"],
  ["01.13", "objecten t.b.v. ondersteuning bouwproces, bouwterreininrichtingen"],
  ["01.14", "objecten t.b.v. ondersteuning bouwproces, transportmaterieel"],
  ["01.15", "objecten t.b.v. ondersteuning bouwproces, tijdelijke nutsvoorzieningen"],
  ["01.16", "objecten t.b.v. ondersteuning bouwproces, klein materieel"],
  ["01.17", "objecten t.b.v. ondersteuning bouwproces, bijzondere abk (specials)"],
  ["01.9", "hoger niet genoemde subelementen"],
  ["01.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["01.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["11.0", "containerelementen"],
  ["11.1", "grond"],
  ["11.10", "grond, algemeen (verzamelniveau)"],
  ["11.11", "grond, vrij maken van bouwput"],
  ["11.12", "grond, grondverzet zonder afvoer"],
  ["11.13", "grond, grondverzet met afvoer"],
  ["11.14", "grond, grondverzet met toevoer"],
  ["11.15", "grond, grondverbetering"],
  ["11.2", "grondwaterverlagingen"],
  ["11.20", "grondwaterverlagingen, algemeen (verzamelniveau)"],
  ["11.21", "grondwaterverlagingen, tijdelijke bemalingen"],
  ["11.8", "voorzieningen"],
  ["11.80", "voorzieningen, algemeen (verzamelniveau)"],
  ["11.81", "voorzieningen, tijdelijke keerwanden"],
  ["11.9", "hoger niet genoemde subelementen"],
  ["11.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["11.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["13.0", "containerelementen"],
  ["13.1", "draagconstructies"],
  ["13.10", "draagconstructies, algemeen (verzamelniveau)"],
  ["13.11", "draagconstructies, dragende vloeren met inklemming"],
  ["13.12", "draagconstructies, dragende vloeren op verende bedding"],
  ["13.13", "draagconstructies, vloeren van lift- en pompputten"],
  ["13.8", "voorzieningen"],
  ["13.80", "voorzieningen, algemeen (verzamelniveau)"],
  ["13.81", "voorzieningen, isolerende laag onder begane grondvloeren"],
  ["13.82", "voorzieningen, bodemafsluiting kruipruimte onder begane grondvloeren"],
  ["13.9", "hoger niet genoemde subelementen"],
  ["13.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["13.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["16.0", "containerelementen"],
  ["16.1", "voeten en balken"],
  ["16.10", "voeten en balken, algemeen (verzamelniveau)"],
  ["16.11", "voeten en balken, voeten/poeren"],
  ["16.12", "voeten en balken, balken/stroken"],
  ["16.2", "keerwanden"],
  ["16.20", "keerwanden, algemeen (verzamelniveau)"],
  ["16.21", "keerwanden, grondkerende wanden"],
  ["16.22", "keerwanden, waterkerende wanden"],
  ["16.23", "keerwanden, grond- en waterkerende wanden"],
  ["16.24", "keerwanden, wanden van lift- en pompputten"],
  ["16.25", "keerwanden, wanden t.b.v. niveauverschillen in begane grondvloeren"],
  ["16.3", "diepwanden"],
  ["16.30", "diepwanden, algemeen (verzamelniveau)"],
  ["16.31", "diepwanden, grondkerende diepwanden"],
  ["16.32", "diepwanden, waterkerende diepwanden"],
  ["16.33", "diepwanden, grond- en waterkerende diepwanden"],
  ["16.34", "diepwanden, trekverankering"],
  ["16.8", "voorzieningen"],
  ["16.80", "voorzieningen, algemeen (verzamelniveau)"],
  ["16.81", "voorzieningen, thermische na-isolatie"],
  ["16.82", "voorzieningen, vochtwerende na-isolatie aan de buitenzijde"],
  ["16.83", "voorzieningen, waterkerende voorzetwanden aan de binnenzijde"],
  ["16.84", "voorzieningen, beschoeiingen"],
  ["16.85", "voorzieningen, geleidewanden"],
  ["16.9", "hoger niet genoemde subelementen"],
  ["16.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["16.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["17.0", "containerelementen"],
  ["17.1", "damplanken"],
  ["17.10", "damplanken, algemeen (verzamelniveau)"],
  ["17.11", "damplanken, grondkerende damplanken"],
  ["17.12", "damplanken, waterkerende damplanken"],
  ["17.13", "damplanken, grond- en waterkerende damplanken"],
  ["17.14", "damplanken, trekverankeringen"],
  ["17.2", "paalfunderingen met gronduitgraving"],
  ["17.20", "paalfunderingen met gronduitgraving, algemeen (verzamelniveau)"],
  ["17.21", "paalfunderingen met gronduitgraving, ondiepe paalfunderingen met gronduitgraving"],
  ["17.22", "paalfunderingen met gronduitgraving, diepe paalfunderingen met gronduitgraving"],
  ["17.23", "paalfunderingen met gronduitgraving, afvoer grond uit boring"],
  ["17.3", "paalfunderingen met grondverdringing"],
  ["17.30", "paalfunderingen met grondverdringing, algemeen (verzamelniveau)"],
  ["17.31", "paalfunderingen met grondverdringing, paalfunderingen met grondverdringing zonder moment"],
  ["17.32", "paalfunderingen met grondverdringing, paalfunderingen met grondverdringing met moment"],
  ["17.4", "paalfunderingen met grondvermenging"],
  ["17.40", "paalfunderingen met grondvermenging, algemeen (verzamelniveau)"],
  ["17.41", "paalfunderingen met grondvermenging, paalfunderingen met grondvermenging"],
  ["17.8", "voorzieningen"],
  ["17.80", "voorzieningen, algemeen (verzamelniveau)"],
  ["17.81", "voorzieningen, thermische na-isolatie"],
  ["17.82", "voorzieningen, vochtwerende na-isolatie"],
  ["17.83", "voorzieningen, deksloven"],
  ["17.84", "voorzieningen, paalkoppen"],
  ["17.85", "voorzieningen, evenwichtsbalken"],
  ["17.9", "hoger niet genoemde subelementen"],
  ["17.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["17.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["21.0", "containerelementen"],
  ["21.1", "draagconstructies"],
  ["21.10", "draagconstructies, algemeen (verzamelniveau)"],
  ["21.11", "draagconstructies, monolithisch"],
  ["21.12", "draagconstructies, samengesteld"],
  ["21.2", "afbouwconstructies"],
  ["21.20", "afbouwconstructies, algemeen (verzamelniveau)"],
  ["21.21", "afbouwconstructies, monolithisch"],
  ["21.22", "afbouwconstructies, samengesteld"],
  ["21.8", "voorzieningen"],
  ["21.80", "voorzieningen, algemeen (verzamelniveau)"],
  ["21.81", "voorzieningen, lateien"],
  ["21.82", "voorzieningen, geveldragers"],
  ["21.83", "voorzieningen, occasionele kolommen"],
  ["21.84", "voorzieningen, occasionele balken"],
  ["21.9", "hoger niet genoemde subelementen"],
  ["21.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["21.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["22.0", "containerelementen"],
  ["22.1", "draagconstructies"],
  ["22.10", "draagconstructies, algemeen (verzamelniveau)"],
  ["22.11", "draagconstructies, monolithisch"],
  ["22.12", "draagconstructies, samengesteld"],
  ["22.2", "afbouwconstructies"],
  ["22.20", "afbouwconstructies, algemeen (verzamelniveau)"],
  ["22.21", "afbouwconstructies, monolithisch"],
  ["22.22", "afbouwconstructies, samengesteld"],
  ["22.8", "voorzieningen"],
  ["22.80", "voorzieningen, algemeen (verzamelniveau)"],
  ["22.81", "voorzieningen, lateien"],
  ["22.82", "voorzieningen, geveldragers"],
  ["22.83", "voorzieningen, occasionele kolommen"],
  ["22.84", "voorzieningen, occasionele balken"],
  ["22.9", "hoger niet genoemde subelementen"],
  ["22.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["22.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["23.0", "containerelementen"],
  ["23.1", "draagconstructies"],
  ["23.10", "draagconstructies, algemeen (verzamelniveau)"],
  ["23.11", "draagconstructies, monolithisch"],
  ["23.12", "draagconstructies, samengesteld"],
  ["23.2", "afbouwconstructies"],
  ["23.20", "afbouwconstructies, algemeen (verzamelniveau)"],
  ["23.21", "afbouwconstructies, monolithisch"],
  ["23.22", "afbouwconstructies, samengesteld"],
  ["23.9", "hoger niet genoemde subelementen"],
  ["23.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["23.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["24.0", "containerelementen"],
  ["24.1", "trappen"],
  ["24.10", "trappen, algemeen (verzamelniveau)"],
  ["24.11", "trappen, rechte steektrappen"],
  ["24.12", "trappen, steektrappen met richtingsverandering"],
  ["24.13", "trappen, trappensleden met verdreven trappen"],
  ["24.14", "trappen, bordessen"],
  ["24.15", "trappen, spiltrappen"],
  ["24.2", "hellingen"],
  ["24.20", "hellingen, algemeen (verzamelniveau)"],
  ["24.21", "hellingen, rechte hellingen"],
  ["24.22", "hellingen, hellingen met richtingsverandering"],
  ["24.23", "hellingen, toegangshellingen t.h.v. openingen"],
  ["24.24", "hellingen, bordessen"],
  ["24.3", "ladders"],
  ["24.30", "ladders, algemeen (verzamelniveau)"],
  ["24.31", "ladders, rechte ladders"],
  ["24.32", "ladders, kooiladders"],
  ["24.34", "ladders, bordessen"],
  ["24.4", "klimijzers"],
  ["24.40", "klimijzers, algemeen (verzamelniveau)"],
  ["24.41", "klimijzers, klimbeugels"],
  ["24.9", "hoger niet genoemde subelementen"],
  ["24.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["24.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["27.0", "containerelementen"],
  ["27.1", "draagconstructies"],
  ["27.10", "draagconstructies, algemeen (verzamelniveau)"],
  ["27.11", "draagconstructies, monolithisch"],
  ["27.12", "draagconstructies, samengesteld"],
  ["27.2", "afbouwconstructies"],
  ["27.20", "afbouwconstructies, algemeen (verzamelniveau)"],
  ["27.21", "afbouwconstructies, monolithisch"],
  ["27.22", "afbouwconstructies, samengesteld"],
  ["27.8", "voorzieningen"],
  ["27.80", "voorzieningen, algemeen (verzamelniveau)"],
  ["27.81", "voorzieningen, gootconstructies"],
  ["27.9", "hoger niet genoemde subelementen"],
  ["27.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["27.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["28.0", "containerelementen"],
  ["28.1", "draagconstructies"],
  ["28.10", "draagconstructies, algemeen (verzamelniveau)"],
  ["28.11", "draagconstructies, kolommen"],
  ["28.12", "draagconstructies, liggers"],
  ["28.13", "draagconstructies, windverbanden"],
  ["28.14", "draagconstructies, vakwerken"],
  ["28.15", "draagconstructies, spaceframes"],
  ["28.2", "afbouwconstructies"],
  ["28.20", "afbouwconstructies, algemeen (verzamelniveau)"],
  ["28.21", "afbouwconstructies, beschermlagen kolommen"],
  ["28.22", "afbouwconstructies, beschermlagen liggers"],
  ["28.23", "afbouwconstructies, beschermlagen windverbanden"],
  ["28.24", "afbouwconstructies, beschermlagen vakwerken"],
  ["28.25", "afbouwconstructies, beschermlagen spaceframes"],
  ["28.9", "hoger niet genoemde subelementen"],
  ["28.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["28.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["31.0", "containerelementen"],
  ["31.1", "niet gevuld"],
  ["31.10", "niet gevuld, algemeen (verzamelniveau)"],
  ["31.11", "niet gevuld, randafwerkingen niet gevulde openingen"],
  ["31.12", "niet gevuld, afwerklagen met bouwfysische functie"],
  ["31.2", "gevuld met puien"],
  ["31.20", "gevuld met puien, algemeen (verzamelniveau)"],
  ["31.21", "gevuld met puien, roostergehelen"],
  ["31.22", "gevuld met puien, raamgehelen"],
  ["31.23", "gevuld met puien, deurgehelen"],
  ["31.24", "gevuld met puien, bedrijfsdeurgehelen"],
  ["31.25", "gevuld met puien, paneelgehelen"],
  ["31.26", "gevuld met puien, profielen"],
  ["31.3", "gevuld met roosters"],
  ["31.30", "gevuld met roosters, algemeen (verzamelniveau)"],
  ["31.31", "gevuld met roosters, roosters met architectonische waarde"],
  ["31.4", "gevuld met ramen"],
  ["31.40", "gevuld met ramen, algemeen (verzamelniveau)"],
  ["31.41", "gevuld met ramen, gesloten ramen"],
  ["31.42", "gevuld met ramen, draaiende ramen"],
  ["31.43", "gevuld met ramen, schuiframen"],
  ["31.5", "gevuld met deuren"],
  ["31.50", "gevuld met deuren, algemeen (verzamelniveau)"],
  ["31.51", "gevuld met deuren, draaideuren"],
  ["31.52", "gevuld met deuren, schuifdeuren"],
  ["31.53", "gevuld met deuren, tourniquets"],
  ["31.6", "gevuld met bedrijfsdeuren"],
  ["31.60", "gevuld met bedrijfsdeuren, algemeen (verzamelniveau)"],
  ["31.61", "gevuld met bedrijfsdeuren, kantel/tuimelpoorten"],
  ["31.62", "gevuld met bedrijfsdeuren, sectionaalpoorten"],
  ["31.63", "gevuld met bedrijfsdeuren, megadoors"],
  ["31.7", "gevuld met panelen"],
  ["31.70", "gevuld met panelen, algemeen (verzamelniveau)"],
  ["31.71", "gevuld met panelen, panelen"],
  ["31.8", "voorzieningen"],
  ["31.80", "voorzieningen, algemeen (verzamelniveau)"],
  ["31.81", "voorzieningen, thermische en akoestische na-isolatie"],
  ["31.82", "voorzieningen, vochtwerende na-isolatie"],
  ["31.83", "voorzieningen, zonneweringen"],
  ["31.84", "voorzieningen, dorpels"],
  ["31.85", "voorzieningen, vensterbanken"],
  ["31.86", "voorzieningen, dagkantafwerkingen"],
  ["31.9", "hoger niet genoemde subelementen"],
  ["31.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["31.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["32.0", "containerelementen"],
  ["32.1", "niet gevuld"],
  ["32.10", "niet gevuld, algemeen (verzamelniveau)"],
  ["32.11", "niet gevuld, randafwerkingen niet gevulde openingen"],
  ["32.12", "niet gevuld, afwerklagen met bouwfysische functie"],
  ["32.2", "gevuld met puien"],
  ["32.20", "gevuld met puien, algemeen (verzamelniveau)"],
  ["32.21", "gevuld met puien, roostergehelen"],
  ["32.22", "gevuld met puien, raamgehelen"],
  ["32.23", "gevuld met puien, deurgehelen"],
  ["32.24", "gevuld met puien, bedrijfsdeurgehelen"],
  ["32.25", "gevuld met puien, paneelgehelen"],
  ["32.26", "gevuld met puien, profielen"],
  ["32.3", "gevuld met roosters"],
  ["32.30", "gevuld met roosters, algemeen (verzamelniveau)"],
  ["32.31", "gevuld met roosters, roosters met architectonische waarde"],
  ["32.4", "gevuld met ramen"],
  ["32.40", "gevuld met ramen, algemeen (verzamelniveau)"],
  ["32.41", "gevuld met ramen, gesloten ramen"],
  ["32.42", "gevuld met ramen, draaiende ramen"],
  ["32.43", "gevuld met ramen, schuiframen"],
  ["32.5", "gevuld met deuren"],
  ["32.50", "gevuld met deuren, algemeen (verzamelniveau)"],
  ["32.51", "gevuld met deuren, draaideuren"],
  ["32.52", "gevuld met deuren, schuifdeuren"],
  ["32.53", "gevuld met deuren, tourniquets"],
  ["32.6", "gevuld met bedrijfsdeuren"],
  ["32.60", "gevuld met bedrijfsdeuren, algemeen (verzamelniveau)"],
  ["32.61", "gevuld met bedrijfsdeuren, kantel/tuimelpoorten"],
  ["32.62", "gevuld met bedrijfsdeuren, sectionaalpoorten"],
  ["32.63", "gevuld met bedrijfsdeuren, megadoors"],
  ["32.7", "gevuld met panelen"],
  ["32.70", "gevuld met panelen, algemeen (verzamelniveau)"],
  ["32.71", "gevuld met panelen, panelen"],
  ["32.8", "voorzieningen"],
  ["32.80", "voorzieningen, algemeen (verzamelniveau)"],
  ["32.81", "voorzieningen, thermische en akoestische na-isolatie"],
  ["32.82", "voorzieningen, vochtwerende na-isolatie"],
  ["32.83", "voorzieningen, verduistering"],
  ["32.84", "voorzieningen, ramentabletten"],
  ["32.85", "voorzieningen, tussendorpels"],
  ["32.9", "hoger niet genoemde subelementen"],
  ["32.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["32.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["33.0", "containerelementen"],
  ["33.1", "niet gevuld"],
  ["33.10", "niet gevuld, algemeen (verzamelniveau)"],
  ["33.11", "niet gevuld, randafwerkingen niet gevulde openingen"],
  ["33.12", "niet gevuld, afwerklagen met bouwfysische functie"],
  ["33.2", "gevuld met vloerpuien"],
  ["33.20", "gevuld met vloerpuien, algemeen (verzamelniveau)"],
  ["33.21", "gevuld met vloerpuien, combinatie gesloten en opengaande delen"],
  ["33.3", "gevuld met vloerroosters"],
  ["33.30", "gevuld met vloerroosters, algemeen (verzamelniveau)"],
  ["33.31", "gevuld met vloerroosters, roosters met architectonische waarde"],
  ["33.4", "gevuld met vloerramen"],
  ["33.40", "gevuld met vloerramen, algemeen (verzamelniveau)"],
  ["33.41", "gevuld met vloerramen, vloerramen"],
  ["33.5", "gevuld met vloerluiken"],
  ["33.50", "gevuld met vloerluiken, algemeen (verzamelniveau)"],
  ["33.51", "gevuld met vloerluiken, vloerluiken zonder uitklapbare trappen"],
  ["33.52", "gevuld met vloerluiken, vloerluiken met uitklapbare trappen"],
  ["33.6", "gevuld met vloerbedrijfsluiken"],
  ["33.60", "gevuld met vloerbedrijfsluiken, algemeen (verzamelniveau)"],
  ["33.61", "gevuld met vloerbedrijfsluiken, vloerbedrijfsluiken"],
  ["33.8", "voorzieningen"],
  ["33.80", "voorzieningen, algemeen (verzamelniveau)"],
  ["33.81", "voorzieningen, thermische en akoestische na-isolatie"],
  ["33.82", "voorzieningen, vochtwerende na-isolatie"],
  ["33.83", "voorzieningen, verduistering"],
  ["33.9", "hoger niet genoemde subelementen"],
  ["33.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["33.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["34.0", "containerelementen"],
  ["34.1", "ballustrades"],
  ["34.10", "balustrades, algemeen (verzamelniveau)"],
  ["34.11", "balustrades, balustrades vloerranden"],
  ["34.12", "balustrades, behandelingen met structurele functie"],
  ["34.2", "leuningen"],
  ["34.20", "leuningen, algemeen (verzamelniveau)"],
  ["34.21", "leuningen, leuningen"],
  ["34.22", "leuningen, behandelingen met structurele functie"],
  ["34.3", "handgrepen"],
  ["34.30", "handgrepen, algemeen (verzamelniveau)"],
  ["34.31", "handgrepen, handgrepen"],
  ["34.32", "handgrepen, behandelingen met structurele functie"],
  ["34.9", "hoger niet genoemde subelementen"],
  ["34.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["34.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["37.0", "containerelementen"],
  ["37.1", "niet gevuld"],
  ["37.10", "niet gevuld, algemeen (verzamelniveau)"],
  ["37.11", "niet gevuld, randafwerkingen niet gevulde openingen"],
  ["37.12", "niet gevuld, afwerklagen met bouwfysische functie"],
  ["37.2", "gevuld met dakpuien"],
  ["37.20", "gevuld met dakpuien, algemeen (verzamelniveau)"],
  ["37.21", "gevuld met dakpuien, combinatie gesloten en opengaande delen"],
  ["37.3", "gevuld met dakroosters"],
  ["37.30", "gevuld met dakroosters, algemeen (verzamelniveau)"],
  ["37.31", "gevuld met dakroosters, roosters met architectonische waarde"],
  ["37.4", "gevuld met dakramen"],
  ["37.40", "gevuld met dakramen, algemeen (verzamelniveau)"],
  ["37.41", "gevuld met dakramen, dakramen"],
  ["37.5", "gevuld met dakluiken"],
  ["37.50", "gevuld met dakluiken, algemeen (verzamelniveau)"],
  ["37.51", "gevuld met dakluiken, dakluiken zonder uitklapbare trappen"],
  ["37.52", "gevuld met dakluiken, dakluiken met uitklapbare trappen"],
  ["37.6", "gevuld met dakbedrijfsluiken"],
  ["37.60", "gevuld met dakbedrijfsluiken, algemeen (verzamelniveau)"],
  ["37.61", "gevuld met dakbedrijfsluiken, dakbedrijfsluiken"],
  ["37.8", "voorzieningen"],
  ["37.80", "voorzieningen, algemeen (verzamelniveau)"],
  ["37.81", "voorzieningen, thermische en akoestische na-isolatie"],
  ["37.82", "voorzieningen, vochtwerende na-isolatie"],
  ["37.83", "voorzieningen, verduistering"],
  ["37.9", "hoger niet genoemde subelementen"],
  ["37.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["37.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["41.0", "containerelementen"],
  ["41.1", "wandafwerkingen middels spouw"],
  ["41.10", "wandafwerkingen middels spouw, algemeen (verzamelniveau)"],
  ["41.11", "wandafwerkingen middels spouw, bekledingen op regelwerk"],
  ["41.2", "wandafwerkingen zonder spouw"],
  ["41.20", "wandafwerkingen zonder spouw, algemeen (verzamelniveau)"],
  ["41.21", "wandafwerkingen zonder spouw, wandafwerkingen"],
  ["41.22", "wandafwerkingen zonder spouw, behandelingen bestaande afwerkingen"],
  ["41.9", "hoger niet genoemde subelementen"],
  ["41.91", "hoger niet genoemde subelementen , fysieke objecten"],
  ["41.92", "hoger niet genoemde subelementen , virtuele objecten"],
  ["42.0", "containerelementen"],
  ["42.1", "wandafwerkingen middels voorzetwanden"],
  ["42.10", "wandafwerkingen middels voorzetwanden, algemeen (verzamelniveau)"],
  ["42.11", "wandafwerkingen middels voorzetwanden, voorzetwanden"],
  ["42.2", "wandafwerkingen zonder voorzetwanden"],
  ["42.20", "wandafwerkingen zonder voorzetwanden, algemeen (verzamelniveau)"],
  ["42.21", "wandafwerkingen zonder voorzetwanden, wandafwerkingen"],
  ["42.22", "wandafwerkingen zonder voorzetwanden, behandelingen bestaande afwerkingen"],
  ["42.9", "hoger niet genoemde subelementen"],
  ["42.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["42.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["43.0", "containerelementen"],
  ["43.1", "verhoogde vloerafwerkingen"],
  ["43.10", "verhoogde vloerafwerkingen, algemeen (verzamelniveau)"],
  ["43.11", "verhoogde vloerafwerkingen, verhoogde vloeren"],
  ["43.2", "niet verhoogde vloerafwerkingen"],
  ["43.20", "niet verhoogde vloerafwerkingen, algemeen (verzamelniveau)"],
  ["43.21", "niet verhoogde vloerafwerkingen, vloerbekleding"],
  ["43.22", "niet verhoogde vloerafwerkingen, behandeling bestaande afwerkingen"],
  ["43.9", "hoger niet genoemde subelementen"],
  ["43.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["43.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["44.0", "containerelementen"],
  ["44.1", "trapafwerkingen"],
  ["44.10", "trapafwerkingen, algemeen (verzamelniveau)"],
  ["44.11", "trapafwerkingen, afwerkingen aan de bovenzijde"],
  ["44.12", "trapafwerkingen, afwerkingen aan de onderzijde"],
  ["44.13", "trapafwerkingen, behandelingen bestaande afwerkingen"],
  ["44.2", "hellingsafwerkingen"],
  ["44.20", "hellingsafwerkingen, algemeen (verzamelniveau)"],
  ["44.21", "hellingsafwerkingen, afwerkingen aan de bovenzijde"],
  ["44.22", "hellingsafwerkingen, afwerkingen aan de onderzijde"],
  ["44.23", "hellingsafwerkingen, behandelingen bestaande afwerkingen"],
  ["44.9", "hoger niet genoemde subelementen"],
  ["44.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["44.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["45.0", "containerelementen"],
  ["45.1", "verlaagde plafondafwerkingen"],
  ["45.10", "verlaagde plafondafwerkingen, algemeen (verzamelniveau)"],
  ["45.11", "verlaagde plafondafwerkingen, verlaagd plafond"],
  ["45.2", "niet verlaagde plafondafwerkingen"],
  ["45.20", "niet verlaagde plafondafwerkingen, algemeen (verzamelniveau)"],
  ["45.21", "niet verlaagde plafondafwerkingen, plafondafwerkingen"],
  ["45.22", "niet verlaagde plafondafwerkingen, behandelingen bestaande afwerkingen"],
  ["45.9", "hoger niet genoemde subelementen"],
  ["45.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["45.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["47.0", "containerelementen"],
  ["47.1", "dakafwerkingen"],
  ["47.10", "dakafwerkingen, algemeen (verzamelniveau)"],
  ["47.11", "dakafwerkingen, dakafwerkingen"],
  ["47.2", "bijzondere constructies"],
  ["47.20", "bijzondere constructies, algemeen (verzamelniveau)"],
  ["47.21", "bijzondere constructies, luifels"],
  ["47.22", "dakafwerkingen, behandelingen bestaande afwerkingen"],
  ["47.9", "hoger niet genoemde subelementen"],
  ["47.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["47.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["52.0", "systeemelementen"],
  ["52.1", "regenwater"],
  ["52.10", "regenwater, algemeen (verzamelniveau)"],
  ["52.11", "regenwater, afvoerinstallaties in het gebouw"],
  ["52.12", "regenwater, afvoerinstallaties buitengevel aan het gebouw"],
  ["52.16", "regenwater, pompinstallaties, afscheiders"],
  ["52.19", "regenwater, waterberging, infiltratie, bezinkputten"],
  ["52.2", "fecaliën"],
  ["52.20", "fecaliën, algemeen (verzamelniveau)"],
  ["52.21", "fecaliën, standaard afvoerinstallaties"],
  ["52.22", "fecaliën, vacuümsystemen"],
  ["52.23", "fecaliën, overdruksystemen"],
  ["52.24", "fecaliën, gescheiden (urine) afvoerinstallaties"],
  ["52.26", "fecaliën, pompinstallaties, afscheiders"],
  ["52.29", "fecaliën, bezinkputten, buffering"],
  ["52.3", "afvalwater"],
  ["52.30", "afvalwater, algemeen (verzamelniveau)"],
  ["52.31", "afvalwater, afvoerinstallaties huishoudelijk afval"],
  ["52.32", "afvalwater, afvoerinstallaties bedrijfsafval"],
  ["52.36", "afvalwater, pompinstallaties, afscheiders"],
  ["52.39", "afvalwater, berging, buffering, bezinkputten"],
  ["52.4", "gecombineerd"],
  ["52.40", "gecombineerd, algemeen (verzamelniveau)"],
  ["52.41", "gecombineerd, geïntegreerde afvoerinstallaties"],
  ["52.46", "gecombineerd, pompinstallaties, afscheiders"],
  ["52.49", "gecombineerd, berging, buffering, bezinkputten"],
  ["52.5", "vuilwaterafvoer speciaal"],
  ["52.50", "vuilwaterafvoer speciaal, algemeen (verzamelniveau)"],
  ["52.51", "vuilwaterafvoer speciaal, afvoerinstallaties chemisch verontreinigd afvalwater"],
  ["52.52", "vuilwaterafvoer speciaal, afvoerinstallaties biologisch besmet afvalwater"],
  ["52.53", "vuilwaterafvoer speciaal, afvoerinstallaties radioactief besmet afvalwater"],
  ["52.56", "vuilwaterafvoer speciaal, pompinstallaties"],
  ["52.59", "vuilwaterafvoer speciaal, berging, buffering, bezinkputten"],
  ["52.6", "vaste stoffen"],
  ["52.60", "vaste stoffen, algemeen (verzamelniveau)"],
  ["52.61", "vaste stoffen, afvoerinstallaties met stortkokers"],
  ["52.62", "vaste stoffen, vacuümsystemen"],
  ["52.63", "vaste stoffen, overdruksystemen"],
  ["52.64", "vaste stoffen, verdichtingsystemen"],
  ["52.65", "vaste stoffen, verbrandingssystemen"],
  ["52.69", "vaste stoffen, berging"],
  ["52.8", "vaste gebouwgebonden voorzieningen"],
  ["52.80", "vaste gebouwgebonden voorzieningen, algemeen (verzamelniveau)"],
  ["52.81", "vaste gebouwgebonden voorzieningen, gebouwgebonden hulpmiddelen"],
  ["52.82", "vaste gebouwgebonden voorzieningen, nutsvoorzieningen"],
  ["52.9", "hoger niet genoemde subelementen"],
  ["52.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["52.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["53.0", "systeemelementen"],
  ["53.1", "drinkwater"],
  ["53.10", "drinkwater, algemeen (verzamelniveau)"],
  ["53.11", "drinkwater, distributieinstallaties"],
  ["53.12", "drinkwater, bronaansluitingen"],
  ["53.13", "drinkwater, reinwaterkelderaansluitingen / ringleidingen"],
  ["53.16", "drinkwater, drukverhogingsinstallaties"],
  ["53.19", "drinkwater, voorraadvaten, reinwaterkelders"],
  ["53.2", "verwarmd tapwater"],
  ["53.20", "verwarmd tapwater, algemeen (verzamelniveau)"],
  ["53.21", "verwarmd tapwater, opwekkers met voorraad"],
  ["53.22", "verwarmd tapwater, opwekkers met doorstroom"],
  ["53.23", "verwarmd tapwater, distributieinstallaties"],
  ["53.26", "verwarmd tapwater, drukverhogingsinstallaties"],
  ["53.3", "bedrijfswater"],
  ["53.30", "bedrijfswater, algemeen (verzamelniveau)"],
  ["53.31", "bedrijfswater, onthard-watersystemen"],
  ["53.32", "bedrijfswater, demi-watersystemen"],
  ["53.33", "bedrijfswater, gedistilleerd-watersystemen"],
  ["53.34", "bedrijfswater, zwembad-watersystemen"],
  ["53.36", "bedrijfswater, drukverhogingsinstallaties"],
  ["53.37", "bedrijfswater, onderbrekingsinstallaties (breektank)"],
  ["53.39", "bedrijfswater, voorraadvaten"],
  ["53.4", "gebruiksstoom en condens"],
  ["53.40", "gebruiksstoom en condens, algemeen (verzamelniveau)"],
  ["53.41", "gebruiksstoom en condens, lage-druk stoomsystemen"],
  ["53.42", "gebruiksstoom en condens, hoge-druk stoomsystemen"],
  ["53.46", "gebruiksstoom en condens, pompinstallatie"],
  ["53.49", "gebruiksstoom en condens, voorraadvaten"],
  ["53.5", "waterbehandeling"],
  ["53.50", "waterbehandeling, algemeen (verzamelniveau)"],
  ["53.51", "waterbehandeling, filtratiesystemen"],
  ["53.52", "waterbehandeling, absorptiesystemen"],
  ["53.53", "waterbehandeling, ontgassingsystemen"],
  ["53.54", "waterbehandeling, destillatiesystemen"],
  ["53.59", "waterbehandeling, voorraadvaten"],
  ["53.6", "grijs water"],
  ["53.60", "grijs water, algemeen (verzamelniveau)"],
  ["53.61", "grijs water, distributieinstallaties"],
  ["53.66", "grijs water, drukverhogingsinstallaties"],
  ["53.69", "grijs water, filtering, berging en buffering"],
  ["53.8", "vaste gebouwgebonden voorzieningen"],
  ["53.80", "vaste gebouwgebonden voorzieningen, algemeen (verzamelniveau)"],
  ["53.81", "vaste gebouwgebonden voorzieningen, gebouwgebonden hulpmiddelen"],
  ["53.82", "vaste gebouwgebonden voorzieningen, nutsvoorzieningen"],
  ["53.9", "hoger niet genoemde subelementen"],
  ["53.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["53.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["54.0", "systeemelementen"],
  ["54.1", "brandstof"],
  ["54.10", "brandstof, algemeen (verzamelniveau)"],
  ["54.11", "brandstof, aardgassysteem / menggassysteem"],
  ["54.12", "brandstof, butaansystemen"],
  ["54.13", "brandstof, propaansystemen"],
  ["54.14", "brandstof, lpg-systemen"],
  ["54.15", "brandstof, biogassystemen"],
  ["54.16", "brandstof, waterstofsystemen"],
  ["54.2", "perslucht"],
  ["54.20", "perslucht, algemeen (verzamelniveau)"],
  ["54.21", "perslucht, persluchtsystemen"],
  ["54.3", "medisch"],
  ["54.30", "medisch, algemeen (verzamelniveau)"],
  ["54.31", "medisch, zuurstofsystemen"],
  ["54.32", "medisch, carbogeensystemen"],
  ["54.33", "medisch, lachgassystemen"],
  ["54.34", "medisch, koolzuursystemen"],
  ["54.35", "medisch, medische luchtsystemen"],
  ["54.4", "technisch"],
  ["54.40", "technisch, algemeen (verzamelniveau)"],
  ["54.41", "technisch, stikstofsystemen"],
  ["54.42", "technisch, waterstofsystemen"],
  ["54.43", "technisch, argonsystemen"],
  ["54.44", "technisch, heliumsystemen"],
  ["54.45", "technisch, acetyleensystemen"],
  ["54.46", "technisch, propaansystemen"],
  ["54.47", "technisch, koolzuursystemen"],
  ["54.48", "technisch, zuurstofsystemen"],
  ["54.49", "technisch, methaansystemen"],
  ["54.5", "industrieel"],
  ["54.50", "industrieel, algemeen (verzamelniveau)"],
  ["54.51", "industrieel, systemen zuivere industriële gassen"],
  ["54.52", "industrieel, systemen industriële menggassen"],
  ["54.6", "vacuüm"],
  ["54.60", "vacuüm, algemeen (verzamelniveau)"],
  ["54.61", "vacuüm, vacuümsystemen"],
  ["54.70", "bijzonder, algemeen (verzamelniveau)"],
  ["54.71", "bijzonder, systemen zuivere gassen- en brandstoftoevoer"],
  ["54.72", "bijzonder, systemen menggassen- en brandstoftoevoer"],
  ["54.8", "vaste gebouwgebonden voorzieningen"],
  ["54.80", "vaste gebouwgebonden voorzieningen, algemeen (verzamelniveau)"],
  ["54.81", "vaste gebouwgebonden voorzieningen, gebouwgebonden hulpmiddelen"],
  ["54.82", "vaste gebouwgebonden voorzieningen, nutsvoorzieningen"],
  ["54.9", "hoger niet genoemde subelementen"],
  ["54.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["54.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["55.0", "systeemelementen"],
  ["55.1", "gasblus"],
  ["55.10", "gasblus, algemeen (verzamelniveau)"],
  ["55.11", "gasblus, inergensystemen"],
  ["55.12", "gasblus, chemisch systemen"],
  ["55.13", "gasblus, zuurstofreductie systemen"],
  ["55.2", "waterblus"],
  ["55.20", "waterblus, algemeen (verzamelniveau)"],
  ["55.21", "waterblus, sprinklersystemen"],
  ["55.22", "waterblus, watermistsystemen"],
  ["55.23", "waterblus, droge blusleidingen"],
  ["55.24", "waterblus, brandslanghaspels"],
  ["55.3", "brandventilatie"],
  ["55.30", "brandventilatie, algemeen (verzamelniveau)"],
  ["55.31", "brandventilatie, rook/warmte systemen"],
  ["55.32", "brandventilatie, overdruksystemen"],
  ["55.8", "vaste gebouwgebonden voorzieningen"],
  ["55.80", "vaste gebouwgebonden voorzieningen, algemeen (verzamelniveau)"],
  ["55.81", "vaste gebouwgebonden voorzieningen, gebouwgebonden hulpmiddelen"],
  ["55.82", "vaste gebouwgebonden voorzieningen, nutsvoorzieningen"],
  ["55.9", "hoger niet genoemde subelementen"],
  ["55.91", "hoger niet genoemde subelementen , fysieke objecten"],
  ["55.92", "hoger niet genoemde subelementen , virtuele objecten"],
  ["56.0", "systeemelementen"],
  ["56.1", "opwekking decentraal"],
  ["56.10", "opwekking decentraal, algemeen (verzamelniveau)"],
  ["56.11", "opwekking decentraal, direct verwarmde toestellen"],
  ["56.12", "opwekking decentraal, stoombevochtigers"],
  ["56.13", "opwekking decentraal, verwarmingsinstallaties"],
  ["56.14", "opwekking decentraal, koel(splits)installaties"],
  ["56.15", "opwekking decentraal, compactinstallaties (airco / wp)"],
  ["56.2", "opwekking centraal"],
  ["56.20", "opwekking centraal, algemeen (verzamelniveau)"],
  ["56.21", "opwekking centraal, warmtepompen"],
  ["56.22", "opwekking centraal, koelmachines"],
  ["56.23", "opwekking centraal, absortiemachines"],
  ["56.24", "opwekking centraal, verwarmingstoestelen (ketel, hr, vr, biomassa)"],
  ["56.25", "opwekking centraal, stoomketels en toebehoren (ontgasser, etc.)"],
  ["56.26", "opwekking centraal, warmtekrachtkoppelingen (wkk) en toebehoren"],
  ["56.27", "opwekking centraal, electrolysers, brandstofcellen"],
  ["56.3", "bron"],
  ["56.30", "bron, algemeen (verzamelniveau)"],
  ["56.31", "bron, warmte koude opslag wko (incl. tegenstroomapparaat)"],
  ["56.32", "bron, gesloten bodemenergiesystemen gbes"],
  ["56.33", "bron, oppervlaktewatersystemen teo (incl. tegenstroomapparaat)"],
  ["56.34", "bron, grond(drink)watersystemen ted"],
  ["56.35", "bron, zonnecollectoren (pvt)"],
  ["56.36", "bron, aardwarmte (geothermie)"],
  ["56.37", "bron, warmtenetten (district / extern)"],
  ["56.38", "bron, koudenetten (district / extern)"],
  ["56.4", "distributie"],
  ["56.40", "distributie, algemeen (verzamelniveau)"],
  ["56.41", "distributie, verwarming"],
  ["56.42", "distributie, koeling"],
  ["56.43", "distributie, gecombineerd (verwarming, koeling)"],
  ["56.5", "opslag (buffer)"],
  ["56.50", "opslag (buffer, algemeen (verzamelniveau)"],
  ["56.51", "opslag (buffer, verwarming"],
  ["56.52", "opslag (buffer, koeling"],
  ["56.53", "opslag (buffer, gecombineerd (verwarming, koeling)"],
  ["56.6", "afgifte"],
  ["56.60", "afgifte, algemeen (verzamelniveau)"],
  ["56.61", "afgifte, radiator/convectorinstallaties"],
  ["56.62", "afgifte, stralingspanelen"],
  ["56.63", "afgifte, oppervlakte verwarming, -koeling (vloeren, betonkern, wanden)"],
  ["56.64", "afgifte, klimaatplafonds (verwarming, koeling)"],
  ["56.65", "afgifte, inductie units (verwarming, koeling)"],
  ["56.66", "afgifte, fancoilunits (verwarming, koeling)"],
  ["56.67", "afgifte, naverwarmers"],
  ["56.68", "afgifte, nakoelers"],
  ["56.8", "vaste gebouwgebonden voorzieningen"],
  ["56.80", "vaste gebouwgebonden voorzieningen, algemeen (verzamelniveau)"],
  ["56.81", "vaste gebouwgebonden voorzieningen, gebouwgebonden hulpmiddelen"],
  ["56.82", "vaste gebouwgebonden voorzieningen, nutsvoorzieningen"],
  ["56.9", "hoger niet genoemde subelementen"],
  ["56.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["56.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["57.0", "systeemelementen"],
  ["57.1", "decentraal"],
  ["57.10", "decentraal, algemeen (verzamelniveau)"],
  ["57.11", "decentraal, natuurlijk regelbaar"],
  ["57.12", "decentraal, natuurlijk niet regelbaar"],
  ["57.13", "decentraal, ventilatie-installaties"],
  ["57.14", "decentraal, afzuiginstallaties"],
  ["57.2", "centraal"],
  ["57.20", "centraal, algemeen (verzamelniveau)"],
  ["57.21", "centraal, ventilatie-installaties"],
  ["57.22", "centraal, afzuiginstallaties"],
  ["57.3", "distributie"],
  ["57.30", "distributie, algemeen (verzamelniveau)"],
  ["57.31", "distributie, kanalen toevoer en retour"],
  ["57.32", "distributie, kanalen separate afzuiginstallaties"],
  ["57.4", "afgifte"],
  ["57.40", "afgifte, algemeen (verzamelniveau)"],
  ["57.41", "afgifte, appendages (volumeregeling)"],
  ["57.42", "afgifte, roosters, luchtornamenten (incl. afzuig)"],
  ["57.8", "vaste gebouwgebonden voorzieningen"],
  ["57.80", "vaste gebouwgebonden voorzieningen, algemeen (verzamelniveau)"],
  ["57.81", "vaste gebouwgebonden voorzieningen, gebouwgebonden hulpmiddelen"],
  ["57.9", "hoger niet genoemde subelementen"],
  ["57.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["57.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["58.0", "systeemelementen"],
  ["58.1", "decentraal"],
  ["58.10", "decentraal, algemeen (verzamelniveau)"],
  ["58.11", "decentraal, hardware"],
  ["58.12", "decentraal, software"],
  ["58.2", "centraal"],
  ["58.20", "centraal, algemeen (verzamelniveau)"],
  ["58.21", "centraal, hardware"],
  ["58.22", "centraal, software"],
  ["58.3", "distributie"],
  ["58.30", "distributie, algemeen (verzamelniveau)"],
  ["58.31", "distributie, regelkasten voedingen / krachtstroom"],
  ["58.32", "distributie, regelkasten zwakstroom (ddc)"],
  ["58.33", "distributie, voedingsleidingen"],
  ["58.34", "distributie, signaalleidingen"],
  ["58.4", "meting en sturing"],
  ["58.40", "meting en sturing, algemeen (verzamelniveau)"],
  ["58.41", "meting en sturing, veldapparatuur voor centrale gebouwinstallaties"],
  ["58.42", "meting en sturing, veldapparatuur voor naregelingen"],
  ["58.8", "vaste gebouwgebonden voorzieningen"],
  ["58.80", "vaste gebouwgebonden voorzieningen, algemeen (verzamelniveau)"],
  ["58.81", "vaste gebouwgebonden voorzieningen, gebouwgebonden hulpmiddelen"],
  ["58.9", "hoger niet genoemde subelementen"],
  ["58.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["58.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["61.0", "systeemelementen"],
  ["61.1", "energie-opwekking"],
  ["61.10", "energie-opwekking, algemeen (verzamelniveau)"],
  ["61.11", "energie-opwekking, noodverlichtingsunits, centraal"],
  ["61.12", "energie-opwekking, nobreak units statisch"],
  ["61.13", "energie-opwekking, noodstroomaggregaten"],
  ["61.14", "energie-opwekking, nobreak units dynamisch"],
  ["61.15", "energie-opwekking, photo voltaic (pv) panelen"],
  ["61.16", "energie-opwekking, wind-energie"],
  ["61.17", "energie-opwekking, brandstofcellen"],
  ["61.18", "energie-opwekking, transformatoren"],
  ["61.2", "aarding en bliksembeveiliging"],
  ["61.20", "aarding en bliksembeveiliging, algemeen (verzamelniveau)"],
  ["61.21", "aarding en bliksembeveiliging, veiligheidsaarding/overspanning"],
  ["61.22", "aarding en bliksembeveiliging, medische aarding"],
  ["61.23", "aarding en bliksembeveiliging, speciale aarding"],
  ["61.24", "aarding en bliksembeveiliging, statische elektriciteit"],
  ["61.25", "aarding en bliksembeveiliging, potentiaalvereffening"],
  ["61.26", "aarding en bliksembeveiliging, bliksemafleiding"],
  ["61.3", "kanalisatie"],
  ["61.30", "kanalisatie, algemeen (verzamelniveau)"],
  ["61.31", "kanalisatie, t.b.v. installaties voor middenspanning"],
  ["61.32", "kanalisatie, t.b.v. installaties voor laagspanning"],
  ["61.33", "kanalisatie, t.b.v. installaties voor communicatie of beveiliging zwakstroom"],
  ["61.4", "energiedistributie middenspanning (> 1kv)"],
  ["61.40", "energiedistributie middenspanning (> 1kv, algemeen (verzamelniveau)"],
  ["61.41", "energiedistributie middenspanning (> 1kv, voedingsleidingen middenspanningsverdelers"],
  ["61.42", "energiedistributie middenspanning (> 1kv, middenspanningsverdelers"],
  ["61.43", "energiedistributie middenspanning (> 1kv, voedingsleidingen middenspanning"],
  ["61.44", "energiedistributie middenspanning (> 1kv, transformatoren"],
  ["61.5", "energiedistributie laagspanning (≤ 1 kv)"],
  ["61.50", "energiedistributie laagspanning (≤ 1 kv, algemeen (verzamelniveau)"],
  ["61.51", "energiedistributie laagspanning (≤ 1 kv, voedingsleidingen laagspanningshoofdverdelers"],
  ["61.52", "energiedistributie laagspanning (≤ 1 kv, laagspanningshoofdverdelers"],
  ["61.53", "energiedistributie laagspanning (≤ 1 kv, voedingsleidingen laagspanning"],
  ["61.54", "energiedistributie laagspanning (≤ 1 kv, sub- en eindverdelers"],
  ["61.55", "energiedistributie laagspanning (≤ 1 kv, medische verdelers (scheidingstransformatoren)"],
  ["61.6", "opslag"],
  ["61.60", "opslag, algemeen (verzamelniveau)"],
  ["61.61", "opslag, batterij-energieopslag"],
  ["61.8", "vaste gebouwgebonden voorzieningen"],
  ["61.80", "vaste gebouwgebonden voorzieningen, algemeen (verzamelniveau)"],
  ["61.81", "vaste gebouwgebonden voorzieningen, gebouwgebonden hulpmiddelen"],
  ["61.82", "vaste gebouwgebonden voorzieningen, nutsvoorzieningen"],
  ["61.9", "hoger niet genoemde subelementen"],
  ["61.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["61.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["62.0", "systeemelementen"],
  ["62.1", "generiek, wissel"],
  ["62.10", "generiek, wissel, algemeen (verzamelniveau)"],
  ["62.11", "generiek, wissel, voedingsleidingen"],
  ["62.12", "generiek, wissel, aansluitpunten"],
  ["62.2", "specifiek, wissel"],
  ["62.20", "specifiek, wissel, algemeen (verzamelniveau)"],
  ["62.21", "specifiek, wissel, voedingsleidingen"],
  ["62.22", "specifiek, wissel, aansluitpunten"],
  ["62.3", "generiek, gelijk"],
  ["62.30", "generiek, gelijk, algemeen (verzamelniveau)"],
  ["62.31", "generiek, gelijk, voedingsleidingen"],
  ["62.32", "generiek, gelijk, aansluitpunten"],
  ["62.4", "specifiek, gelijk"],
  ["62.40", "specifiek, gelijk, algemeen (verzamelniveau)"],
  ["62.41", "specifiek, gelijk, voedingsleidingen"],
  ["62.42", "specifiek, gelijk, aansluitpunten"],
  ["62.8", "vaste gebouwgebonden voorzieningen"],
  ["62.80", "vaste gebouwgebonden voorzieningen, algemeen (verzamelniveau)"],
  ["62.81", "vaste gebouwgebonden voorzieningen, gebouwgebonden hulpmiddelen"],
  ["62.9", "hoger niet genoemde subelementen"],
  ["62.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["62.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["63.0", "systeemelementen"],
  ["63.1", "bediening, regeling en signalering"],
  ["63.10", "bediening, regeling en signalering, algemeen (verzamelniveau)"],
  ["63.11", "bediening, regeling en signalering, voedingsleidingen"],
  ["63.12", "bediening, regeling en signalering, schakelaars"],
  ["63.13", "bediening, regeling en signalering, signalering"],
  ["63.2", "standaard armaturen"],
  ["63.20", "standaard armaturen, algemeen (verzamelniveau)"],
  ["63.21", "standaard armaturen, armaturen"],
  ["63.22", "standaard armaturen, noodarmaturen"],
  ["63.3", "overige armaturen"],
  ["63.30", "overige armaturen, algemeen (verzamelniveau)"],
  ["63.31", "overige armaturen, reclameverlichting"],
  ["63.4", "vluchtwegsignalering"],
  ["63.40", "vluchtwegsignalering, algemeen (verzamelniveau)"],
  ["63.41", "vluchtwegsignalering, centrale sturing vluchtwegsignalering"],
  ["63.42", "vluchtwegsignalering, armaturen"],
  ["63.43", "vluchtwegsignalering, voedingsleidingen"],
  ["63.44", "vluchtwegsignalering, signaalleidingen"],
  ["63.8", "vaste gebouwgebonden voorzieningen"],
  ["63.80", "vaste gebouwgebonden voorzieningen, algemeen (verzamelniveau)"],
  ["63.81", "vaste gebouwgebonden voorzieningen, gebouwgebonden hulpmiddelen"],
  ["63.9", "hoger niet genoemde subelementen"],
  ["63.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["63.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["64.0", "systeemelementen"],
  ["64.1", "signalen"],
  ["64.10", "signalen, algemeen (verzamelniveau)"],
  ["64.11", "signalen, algemene signalering"],
  ["64.13", "signalen, tijdsignalering"],
  ["64.14", "signalen, aanwezigheids- en beletsignalering"],
  ["64.2", "geluiden"],
  ["64.20", "geluiden, algemeen (verzamelniveau)"],
  ["64.21", "geluiden, telefoon"],
  ["64.22", "geluiden, intercom"],
  ["64.23", "geluiden, radio/mobilofoon"],
  ["64.24", "geluiden, geluidsdistributie"],
  ["64.25", "geluiden, vertaalinstallaties"],
  ["64.26", "geluiden, conferentieinstallaties"],
  ["64.3", "beelden"],
  ["64.30", "beelden, algemeen (verzamelniveau)"],
  ["64.31", "beelden, gesloten televisiecircuits"],
  ["64.32", "beelden, beeldreproductie"],
  ["64.33", "beelden, film/dia/overhead"],
  ["64.34", "beelden, vergader- en presentatieinstallaties"],
  ["64.5", "geïntegreerde systemen, data"],
  ["64.50", "geïntegreerde systemen, data, algemeen (verzamelniveau)"],
  ["64.51", "geïntegreerde systemen, data, centrale apparatuur"],
  ["64.52", "geïntegreerde systemen, data, distributie bekabeling, voedings- en signaalleidingen"],
  ["64.53", "geïntegreerde systemen, data, generiek, aansluitpunten"],
  ["64.54", "geïntegreerde systemen, data, specifiek aansluitpunten"],
  ["64.55", "geïntegreerde systemen, data, decentrale apparatuur"],
  ["64.6", "antenne-inrichtingen"],
  ["64.60", "antenne-inrichtingen, algemeen (verzamelniveau)"],
  ["64.61", "antenne-inrichtingen, centrale apparatuur"],
  ["64.62", "antenne-inrichtingen, voedings- en signaalleidingen"],
  ["64.63", "antenne-inrichtingen, decentrale apparatuur"],
  ["64.8", "vaste gebouwgebonden voorzieningen"],
  ["64.80", "vaste gebouwgebonden voorzieningen, algemeen (verzamelniveau)"],
  ["64.81", "vaste gebouwgebonden voorzieningen, gebouwgebonden hulpmiddelen"],
  ["64.9", "hoger niet genoemde subelementen"],
  ["64.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["64.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["65.0", "systeemelementen"],
  ["65.1", "brandmeldings- en ontruimingsinstallatie"],
  ["65.10", "brandmeldings- en ontruimingsinstallatie, algemeen (verzamelniveau)"],
  ["65.11", "brandmeldings- en ontruimingsinstallatie, detectie"],
  ["65.12", "brandmeldings- en ontruimingsinstallatie, alarmering"],
  ["65.13", "brandmeldings- en ontruimingsinstallatie, voedingsleidingen"],
  ["65.2", "braak-en toegangsbeheer"],
  ["65.20", "braak-en toegangsbeheer, algemeen (verzamelniveau)"],
  ["65.21", "braak-en toegangsbeheer, detectie"],
  ["65.22", "braak-en toegangsbeheer, alarmering"],
  ["65.23", "braak-en toegangsbeheer, toegangsbeheer"],
  ["65.24", "braak-en toegangsbeheer, cctv"],
  ["65.3", "detectie- en alarmeringsinstallatie"],
  ["65.30", "detectie- en alarmeringsinstallatie, algemeen (verzamelniveau)"],
  ["65.31", "detectie- en alarmeringsinstallatie, zon- en lichtwering"],
  ["65.32", "detectie- en alarmeringsinstallatie, elektromagnetische installaties"],
  ["65.34", "detectie- en alarmeringsinstallatie, gassenbeveiligingsapparatuur"],
  ["65.4", "sociale alarmeringsinstallatie"],
  ["65.40", "sociale alarmeringsinstallatie, algemeen (verzamelniveau)"],
  ["65.41", "sociale alarmeringsinstallatie, sociale alarmeringsapparatuur"],
  ["65.42", "sociale alarmeringsinstallatie, algemene personenoproepapparatuur"],
  ["65.43", "sociale alarmeringsinstallatie, algemene zusteroproepapparatuur"],
  ["65.8", "vaste gebouwgebonden voorzieningen"],
  ["65.80", "vaste gebouwgebonden voorzieningen, algemeen (verzamelniveau)"],
  ["65.81", "vaste gebouwgebonden voorzieningen, gebouwgebonden hulpmiddelen"],
  ["65.9", "hoger niet genoemde subelementen"],
  ["65.91", "hoger niet genoemde subelementen , fysieke objecten"],
  ["65.92", "hoger niet genoemde subelementen , virtuele objecten"],
  ["66.0", "systeemelementen"],
  ["66.1", "liftinstallaties"],
  ["66.10", "liftinstallaties, algemeen (verzamelniveau)"],
  ["66.11", "liftinstallaties, tractieliften"],
  ["66.12", "liftinstallaties, hydraulische liften"],
  ["66.13", "liftinstallaties, trappenliften"],
  ["66.14", "liftinstallaties, heftableaus"],
  ["66.2", "roltrappen en rolpaden"],
  ["66.20", "roltrappen en rolpaden, algemeen (verzamelniveau)"],
  ["66.21", "roltrappen en rolpaden, roltrappen"],
  ["66.22", "roltrappen en rolpaden, rolpaden"],
  ["66.3", "goederen"],
  ["66.30", "goederen, algemeen (verzamelniveau)"],
  ["66.31", "goederen, goederenliften"],
  ["66.32", "goederen, goederenheffers"],
  ["66.33", "goederen, baantransportmiddelen"],
  ["66.34", "goederen, bandtransportmiddelen"],
  ["66.35", "goederen, baktransportmiddelen"],
  ["66.36", "goederen, hijswerktuigen en takels"],
  ["66.37", "goederen, vrije-baan-transportvoertuigen"],
  ["66.4", "documenten"],
  ["66.40", "documenten, algemeen (verzamelniveau)"],
  ["66.41", "documenten, buizenpost"],
  ["66.42", "documenten, railcontainer banen"],
  ["66.43", "documenten, bandtransportmiddelen"],
  ["66.8", "vaste gebouwgebonden voorzieningen"],
  ["66.80", "vaste gebouwgebonden voorzieningen, algemeen (verzamelniveau)"],
  ["66.81", "vaste gebouwgebonden voorzieningen, gebouwgebonden hulpmiddelen"],
  ["66.9", "hoger niet genoemde subelementen"],
  ["66.91", "hoger niet genoemde subelementen , fysieke objecten"],
  ["66.92", "hoger niet genoemde subelementen , virtuele objecten"],
  ["67.0", "systeemelementen"],
  ["67.2", "centrale apparatuur"],
  ["67.20", "centrale apparatuur, algemeen (verzamelniveau)"],
  ["67.21", "centrale apparatuur, systeemconfiguratie hardware"],
  ["67.22", "centrale apparatuur, systeemconfiguratie software"],
  ["67.3", "distributie"],
  ["67.30", "distributie, algemeen (verzamelniveau)"],
  ["67.31", "distributie, regelkast"],
  ["67.32", "distributie, voedingsleidingen"],
  ["67.33", "distributie, signaalleidingen"],
  ["67.4", "meting en sturing"],
  ["67.40", "meting en sturing, algemeen (verzamelniveau)"],
  ["67.41", "meting en sturing, veldapparatuur componenten managementsystemen"],
  ["67.42", "meting en sturing, veldapparatuur componenten signalering"],
  ["67.8", "vaste gebouwgebonden voorzieningen"],
  ["67.80", "vaste gebouwgebonden voorzieningen, algemeen (verzamelniveau)"],
  ["67.81", "vaste gebouwgebonden voorzieningen, gebouwgebonden hulpmiddelen"],
  ["67.9", "hoger niet genoemde subelementen"],
  ["67.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["67.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["71.0", "containerelementen"],
  ["71.1", "verkeersvoorzieningen"],
  ["71.10", "verkeersvoorzieningen, algemeen (verzamelniveau)"],
  ["71.11", "verkeersvoorzieningen, wegmarkeringen"],
  ["71.12", "verkeersvoorzieningen, wegbewijzering"],
  ["71.13", "verkeersvoorzieningen, weggeleiders"],
  ["71.14", "verkeersvoorzieningen, wieldwingers"],
  ["71.2", "nood- en evacuatieaanduidingen"],
  ["71.20", "nood- en evacuatieaanduidingen , algemeen (verzamelniveau)"],
  ["71.21", "nood- en evacuatieaanduidingen , standaard"],
  ["71.22", "nood- en evacuatieaanduidingen , bijzonder"],
  ["71.3", "postbedeling"],
  ["71.30", "postbedeling, algemeen (verzamelniveau)"],
  ["71.31", "postbedeling, huisnummeraanduiding"],
  ["71.32", "postbedeling, brievenbusgehelen gebouwgebonden"],
  ["71.33", "postbedeling, brievenbusgehelen niet gebouw gebonden"],
  ["71.34", "postbedeling, brievenbusklep"],
  ["71.9", "hoger niet genoemde subelementen"],
  ["71.91", "hoger niet genoemde subelementen , fysieke objecten"],
  ["71.92", "hoger niet genoemde subelementen , virtuele objecten"],
  ["72.0", "containerelementen"],
  ["72.1", "vast meubilair voor werken, rusten en slapen"],
  ["72.10", "vast meubilair voor werken, rusten en slapen, algemeen (verzamelniveau)"],
  ["72.11", "vast meubilair voor werken, rusten en slapen, meubilering"],
  ["72.12", "vast meubilair voor werken, rusten en slapen, lichtweringen"],
  ["72.13", "vast meubilair voor werken, rusten en slapen, beschermende inrichtingen"],
  ["72.2", "vaste ontvangstbalies"],
  ["72.20", "vaste ontvangstbalies, algemeen (verzamelniveau)"],
  ["72.21", "vaste ontvangstbalies, receptiebalies"],
  ["72.22", "vaste ontvangstbalies, garderobebalies"],
  ["72.9", "hoger niet genoemde subelementen"],
  ["72.91", "hoger niet genoemde subelementen , fysieke objecten"],
  ["72.92", "hoger niet genoemde subelementen , virtuele objecten"],
  ["73.0", "containerelementen"],
  ["73.1", "professionele keukeninrichtingen"],
  ["73.10", "professionele keukeninrichtingen, algemeen (verzamelniveau)"],
  ["73.11", "professionele keukeninrichtingen, keuken meubilering"],
  ["73.12", "professionele keukeninrichtingen, keuken apparatuur"],
  ["73.2", "particuliere keukeninrichtingen"],
  ["73.20", "particuliere keukeninrichtingen, algemeen (verzamelniveau)"],
  ["73.21", "particuliere keukeninrichtingen, keuken meubilering"],
  ["73.22", "particuliere keukeninrichtingen, keuken apparatuur"],
  ["73.3", "vaste uitgiftebalies"],
  ["73.30", "vaste uitgiftebalies, algemeen (verzamelniveau)"],
  ["73.31", "vaste uitgiftebalies, uitgiftebalies"],
  ["73.32", "vaste uitgiftebalies, toonbanken"],
  ["73.33", "vaste uitgiftebalies, buffetbalies"],
  ["73.34", "vaste uitgiftebalies, barmeubels"],
  ["73.9", "hoger niet genoemde subelementen"],
  ["73.91", "hoger niet genoemde subelementen , fysieke objecten"],
  ["73.92", "hoger niet genoemde subelementen , virtuele objecten"],
  ["74.0", "containerelementen"],
  ["74.1", "sanitaire toestellen"],
  ["74.10", "sanitaire toestellen, algemeen (verzamelniveau)"],
  ["74.11", "sanitaire toestellen, toiletcombinaties"],
  ["74.12", "sanitaire toestellen, bidetcombinaties"],
  ["74.13", "sanitaire toestellen, urinoircombinaties"],
  ["74.14", "sanitaire toestellen, wastafelcombinaties"],
  ["74.15", "sanitaire toestellen, handwassercombinaties"],
  ["74.16", "sanitaire toestellen, douchecombinaties"],
  ["74.17", "sanitaire toestellen, badcombinaties"],
  ["74.2", "vast meubilair voor inbouw sanitaire toestellen"],
  ["74.20", "vast meubilair voor inbouw sanitaire toestellen, algemeen (verzamelniveau)"],
  ["74.21", "vast meubilair voor inbouw sanitaire toestellen, sanitairmeubilering"],
  ["74.3", "toebehoren sanitaire toestellen"],
  ["74.30", "toebehoren sanitaire toestellen, algemeen (verzamelniveau)"],
  ["74.31", "toebehoren sanitaire toestellen, handdoekhouders"],
  ["74.32", "toebehoren sanitaire toestellen, dispensers"],
  ["74.33", "toebehoren sanitaire toestellen, spiegels"],
  ["74.34", "toebehoren sanitaire toestellen, schaamschotten"],
  ["74.9", "hoger niet genoemde subelementen"],
  ["74.91", "hoger niet genoemde subelementen , fysieke objecten"],
  ["74.92", "hoger niet genoemde subelementen , virtuele objecten"],
  ["75.0", "containerelementen"],
  ["75.1", "exterieur onderhoudsinrichtingen"],
  ["75.10", "exterieur onderhoudsinrichtingen, algemeen (verzamelniveau)"],
  ["75.11", "exterieur onderhoudsinrichtingen, glazenwasinstallaties"],
  ["75.2", "interieur onderhoudsinrichtingen"],
  ["75.20", "interieur onderhoudsinrichtingen, algemeen (verzamelniveau)"],
  ["75.21", "interieur onderhoudsinrichtingen, centrale stofzuigersystemen"],
  ["75.9", "hoger niet genoemde subelementen"],
  ["75.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["75.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["76.0", "containerelementen"],
  ["76.1", "vast meubilair uitsluitend voor opslag"],
  ["76.10", "vast meubilair uitsluitend voor opslag, algemeen (verzamelniveau)"],
  ["76.11", "vast meubilair uitsluitend voor opslag, stellingen"],
  ["76.12", "vast meubilair uitsluitend voor opslag, legplanken"],
  ["76.13", "vast meubilair uitsluitend voor opslag, kasten"],
  ["76.2", "vaste opslaginrichtingen met speciale eigenschappen"],
  ["76.20", "vaste opslaginrichtingen met speciale eigenschappen, algemeen (verzamelniveau)"],
  ["76.21", "vaste opslaginrichtingen met speciale eigenschappen, bankkluizen"],
  ["76.22", "vaste opslaginrichtingen met speciale eigenschappen, brandkluizen"],
  ["76.23", "vaste opslaginrichtingen met speciale eigenschappen, koelcellen"],
  ["76.9", "hoger niet genoemde subelementen"],
  ["76.91", "hoger niet genoemde subelementen, fysieke objecten"],
  ["76.92", "hoger niet genoemde subelementen, virtuele objecten"],
  ["77.0", "containerelementen"],
  ["77.1", "molens"],
  ["77.10", "molens, algemeen (verzamelniveau)"],
  ["77.11", "molens, het gevlucht"],
  ["77.12", "molens, assen en spillen"],
  ["77.13", "molens, molenwielen"],
  ["77.14", "molens, vang"],
  ["77.15", "molens, inrichtingen"],
  ["77.2", "bedrijfsinrichtingen"],
  ["77.20", "bedrijfsinrichtingen, algemeen (verzamelniveau)"],
  ["77.21", "bedrijfsinrichtingen, fabrieksinrichtingen"],
  ["77.22", "bedrijfsinrichtingen, cleanroominrichtingen"],
  ["77.23", "bedrijfsinrichtingen, datacenterinrichtingen"],
  ["77.9", "hoger niet genoemde subelementen"],
  ["77.91", "hoger niet genoemde subelementen , fysieke objecten"],
  ["77.92", "hoger niet genoemde subelementen , virtuele objecten"],
  ["78.0", "containerelementen"],
  ["78.1", "standaard"],
  ["78.10", "standaard, algemeen (verzamelniveau)"],
  ["78.2", "bijzonder"],
  ["78.20", "bijzonder, algemeen (verzamelniveau)"],
  ["78.9", "hoger niet genoemde subelementen"],
  ["81.0", "containerelementen"],
  ["81.1", "verkeersvoorzieningen"],
  ["81.10", "verkeersvoorzieningen, algemeen (verzamelniveau)"],
  ["81.11", "verkeersvoorzieningen, wegmarkeringen"],
  ["81.12", "verkeersvoorzieningen, wegbewijzering"],
  ["81.13", "verkeersvoorzieningen, weggeleiders"],
  ["81.2", "nood- en evacuatieaanduidingen"],
  ["81.20", "nood- en evacuatieaanduidingen , algemeen (verzamelniveau)"],
  ["81.21", "nood- en evacuatieaanduidingen , standaard"],
  ["81.22", "nood- en evacuatieaanduidingen , bijzonder"],
  ["81.9", "hoger niet genoemde subelementen"],
  ["82.0", "containerelementen"],
  ["82.1", "standaard"],
  ["82.10", "standaard, algemeen (verzamelniveau)"],
  ["82.11", "standaard, meubilering"],
  ["82.12", "standaard, apparatuur"],
  ["82.13", "standaard, gereedschap"],
  ["82.2", "bijzonder"],
  ["82.20", "bijzonder, algemeen (verzamelniveau)"],
  ["82.21", "bijzonder, meubilering"],
  ["82.22", "bijzonder, apparatuur"],
  ["82.23", "bijzonder, gereedschap"],
  ["82.9", "hoger niet genoemde subelementen"],
  ["83.0", "containerelementen"],
  ["83.1", "standaard"],
  ["83.10", "standaard, algemeen (verzamelniveau)"],
  ["83.11", "standaard, keuken apparatuur"],
  ["83.12", "standaard, keuken gereedschap"],
  ["83.2", "bijzonder"],
  ["83.20", "bijzonder, algemeen (verzamelniveau)"],
  ["83.21", "bijzonder, keuken apparatuur"],
  ["83.22", "bijzonder, keuken gereedschap"],
  ["83.9", "hoger niet genoemde subelementen"],
  ["84.0", "containerelementen"],
  ["84.1", "standaard"],
  ["84.10", "standaard, algemeen (verzamelniveau)"],
  ["84.11", "standaard, afvalvoorzieningen"],
  ["84.12", "standaard, voorzieningen ten behoeve van hygiene"],
  ["84.13", "standaard, accessoires"],
  ["84.2", "bijzonder"],
  ["84.20", "bijzonder, algemeen (verzamelniveau)"],
  ["84.21", "bijzonder, afvalvoorzieningen"],
  ["84.22", "bijzonder, voorzieningen ten behoeve van hygiene"],
  ["84.23", "bijzonder, accessoires"],
  ["84.9", "hoger niet genoemde subelementen"],
  ["85.0", "containerelementen"],
  ["85.1", "standaard"],
  ["85.10", "standaard, algemeen (verzamelniveau)"],
  ["85.11", "standaard, schoonmaak apparatuur"],
  ["85.12", "standaard, vuilopslag"],
  ["85.13", "standaard, vuiltransport"],
  ["85.2", "bijzonder"],
  ["85.20", "bijzonder, algemeen (verzamelniveau)"],
  ["85.21", "bijzonder, schoonmaak apparatuur"],
  ["85.22", "bijzonder, vuilopslag"],
  ["85.23", "bijzonder, vuiltransport"],
  ["85.9", "hoger niet genoemde subelementen"],
  ["86.0", "containerelementen"],
  ["86.1", "los meubilair uitsluitend voor opslag"],
  ["86.10", "los meubilair uitsluitend voor opslag, algemeen (verzamelniveau)"],
  ["86.11", "los meubilair uitsluitend voor opslag, stellingen"],
  ["86.12", "los meubilair uitsluitend voor opslag, legplanken"],
  ["86.13", "los meubilair uitsluitend voor opslag, kasten"],
  ["86.2", "los opslaginrichtingen met speciale eigenschappen"],
  ["86.20", "los opslaginrichtingen met speciale eigenschappen, algemeen (verzamelniveau)"],
  ["86.21", "los opslaginrichtingen met speciale eigenschappen, bankkluizen"],
  ["86.22", "los opslaginrichtingen met speciale eigenschappen, brandkluizen"],
  ["86.23", "los opslaginrichtingen met speciale eigenschappen, koelcellen"],
  ["86.9", "hoger niet genoemde subelementen"],
  ["87.0", "containerelementen"],
  ["87.1", "bedrijfsspecifieke inrichtingen"],
  ["87.10", "bedrijfsspecifieke inrichtingen, algemeen (verzamelniveau)"],
  ["87.11", "bedrijfsspecifieke inrichtingen, standaard"],
  ["87.12", "bedrijfsspecifieke inrichtingen, bijzonder"],
  ["87.2", "ict-inrichtingen"],
  ["87.20", "ict-inrichtingen, algemeen (verzamelniveau)"],
  ["87.21", "ict-inrichtingen, standaard"],
  ["87.22", "ict-inrichtingen, bijzonder"],
  ["87.3", "klimaatinrichtingen"],
  ["87.30", "klimaatinrichtingen, algemeen (verzamelniveau)"],
  ["87.31", "klimaatinrichtingen, standaard"],
  ["87.32", "klimaatinrichtingen, bijzonder"],
  ["87.9", "hoger niet genoemde subelementen"],
  ["88.0", "containerelementen"],
  ["88.1", "standaard"],
  ["88.10", "standaard, algemeen (verzamelniveau)"],
  ["88.2", "bijzonder"],
  ["88.20", "bijzonder, algemeen (verzamelniveau)"],
  ["88.9", "hoger niet genoemde subelementen"],
  ["91.0", "containerelementen"],
  ["91.1", "verwijderen obstakels"],
  ["91.2", "grond"],
  ["91.20", "grond, algemeen (verzamelniveau)"],
  ["91.21", "grond, vrijmaken van terrein rond bouwput"],
  ["91.22", "grond, grondverzet zonder afvoer"],
  ["91.23", "grond, grondverzet met afvoer"],
  ["91.24", "grond, grondverzet met toevoer"],
  ["91.25", "grond, grondverbetering"],
  ["91.3", "grondwaterverlagingen"],
  ["91.30", "grondwaterverlagingen, algemeen (verzamelniveau)"],
  ["91.31", "grondwaterverlagingen, tijdelijke bemalingen"],
  ["91.8", "voorzieningen"],
  ["91.80", "voorzieningen, algemeen (verzamelniveau)"],
  ["91.81", "voorzieningen, tijdelijke keerwanden"],
  ["91.9", "hoger niet genoemde subelementen"],
  ["92.0", "containerelementen"],
  ["92.1", "opstallen"],
  ["92.10", "opstallen, algemeen (verzamelniveau)"],
  ["92.11", "opstallen, parkeergebouwen"],
  ["92.12", "opstallen, fietsenstallingen"],
  ["92.13", "opstallen, nutsopstallen"],
  ["92.14", "opstallen, containerbehuizingen"],
  ["92.15", "opstallen, tuinhuizen"],
  ["92.2", "overkappingen"],
  ["92.20", "overkappingen, algemeen (verzamelniveau)"],
  ["92.21", "overkappingen, carports"],
  ["92.22", "overkappingen, fietsenstallingen"],
  ["92.23", "overkappingen, terrasoverkappingen"],
  ["92.24", "overkappingen, containerbehuizingen"],
  ["92.25", "overkappingen, prielen"],
  ["92.3", "open constructies"],
  ["92.30", "open constructies, algemeen (verzamelniveau)"],
  ["92.33", "open constructies, pergola's"],
  ["92.34", "open constructies, containerbehuizingen"],
  ["92.9", "hoger niet genoemde subelementen"],
  ["93.0", "containerelementen"],
  ["93.1", "afscheidingen"],
  ["93.10", "afscheidingen, algemeen (verzamelniveau)"],
  ["93.11", "afscheidingen, schermen en wanden"],
  ["93.12", "afscheidingen, hekken"],
  ["93.13", "afscheidingen, balustraden"],
  ["93.2", "toegangselementen"],
  ["93.20", "toegangselementen, algemeen (verzamelniveau)"],
  ["93.21", "toegangselementen, poorten"],
  ["93.22", "toegangselementen, slagbomen"],
  ["93.9", "hoger niet genoemde subelementen"],
  ["94.0", "containerelementen"],
  ["94.1", "verhardingen"],
  ["94.10", "verhardingen, algemeen (verzamelniveau)"],
  ["94.11", "verhardingen, niet waterdoorlatende verharding"],
  ["94.12", "verhardingen, waterdoorlatende verharding"],
  ["94.2", "beplantingen"],
  ["94.20", "beplantingen, algemeen (verzamelniveau)"],
  ["94.21", "beplantingen, bomen"],
  ["94.22", "beplantingen, struiken"],
  ["94.23", "beplantingen, hagen"],
  ["94.24", "beplantingen, bodembedekkers"],
  ["94.25", "beplantingen, graszoden"],
  ["94.3", "waterpartijen"],
  ["94.30", "waterpartijen, algemeen (verzamelniveau)"],
  ["94.31", "waterpartijen, natuurlijke vijvers"],
  ["94.32", "waterpartijen, kunstmatige vijvers"],
  ["94.33", "waterpartijen, vijverornamenten"],
  ["94.34", "waterpartijen, duikers"],
  ["94.4", "terreinelementen"],
  ["94.40", "terreinelementen, algemeen (verzamelniveau)"],
  ["94.41", "terreinelementen, keerwanden"],
  ["94.42", "terreinelementen, bloktreden en trappen"],
  ["94.43", "terreinelementen, hellingen"],
  ["94.9", "hoger niet genoemde subelementen"],
  ["95.0", "containerelementen"],
  ["95.1", "vloeistoffen en gasinstallaties"],
  ["95.10", "vloeistoffen en gasinstallaties, algemeen (verzamelniveau)"],
  ["95.11", "vloeistoffen en gasinstallaties, afvoeren"],
  ["95.12", "vloeistoffen en gasinstallaties, watertoevoer"],
  ["95.13", "vloeistoffen en gasinstallaties, gassen- en brandstoftoevoer"],
  ["95.2", "klimaatinstallaties"],
  ["95.20", "klimaatinstallaties, algemeen (verzamelniveau)"],
  ["95.21", "klimaatinstallaties, werktuigkundige brandveiligheid"],
  ["95.22", "klimaatinstallaties, verwarming en koeling"],
  ["95.23", "klimaatinstallaties, luchtbehandeling"],
  ["95.3", "regelingen"],
  ["95.30", "regelingen, algemeen (verzamelniveau)"],
  ["95.31", "regelingen, meting en sturing"],
  ["95.9", "hoger niet genoemde subelementen"],
  ["96.0", "containerelementen"],
  ["96.1", "centrale elektrotechnische voorzieningen"],
  ["96.10", "centrale elektrotechnische voorzieningen, algemeen (verzamelniveau)"],
  ["96.11", "centrale elektrotechnische voorzieningen, opwekking"],
  ["96.12", "centrale elektrotechnische voorzieningen, distributie"],
  ["96.2", "energievoorziening gebruikersaansluitingen"],
  ["96.20", "energievoorziening gebruikersaansluitingen, algemeen (verzamelniveau)"],
  ["96.21", "energievoorziening gebruikersaansluitingen, apparatuur"],
  ["96.22", "energievoorziening gebruikersaansluitingen, verlichting"],
  ["96.3", "decentraal, signaal"],
  ["96.30", "decentraal, signaal, algemeen (verzamelniveau)"],
  ["96.31", "decentraal, signaal, communicatie"],
  ["96.32", "decentraal, signaal, beveiliging"],
  ["96.4", "transport"],
  ["96.40", "transport, algemeen (verzamelniveau)"],
  ["96.41", "transport, liften"],
  ["96.42", "transport, roltrappen"],
  ["96.43", "transport, rolpaden"],
  ["96.7", "asset management systemen"],
  ["96.70", "asset management systemen, algemeen (verzamelniveau)"],
  ["96.73", "asset management systemen, distributie, bekabeling"],
  ["96.74", "asset management systemen, meting en sturing"],
  ["96.9", "hoger niet genoemde subelementen"],
  ["97.0", "containerelementen"],
  ["97.1", "vaste verkeersinrichtingen"],
  ["97.10", "vaste verkeersinrichtingen, algemeen (verzamelniveau)"],
  ["97.11", "vaste verkeersinrichtingen, wegmarkeringen"],
  ["97.12", "vaste verkeersinrichtingen, vaste wegbewijzering"],
  ["97.13", "vaste verkeersinrichtingen, weggeleiders"],
  ["97.14", "vaste verkeersinrichtingen, wieldwingers"],
  ["97.2", "vaste gebruikersinrichtingen"],
  ["97.20", "vaste gebruikersinrichtingen, algemeen (verzamelniveau)"],
  ["97.21", "vaste gebruikersinrichtingen, meubilering"],
  ["97.22", "vaste gebruikersinrichtingen, speeltoestellen"],
  ["97.23", "vaste gebruikersinrichtingen, sporttoestellen"],
  ["97.5", "vaste onderhoudsinrichtingen"],
  ["97.50", "vaste onderhoudsinrichtingen, algemeen (verzamelniveau)"],
  ["97.51", "vaste onderhoudsinrichtingen, bewateringssystemen"],
  ["97.6", "vaste opslaginrichtingen"],
  ["97.60", "vaste opslaginrichtingen, algemeen (verzamelniveau)"],
  ["97.61", "vaste opslaginrichtingen, fietsrekken"],
  ["97.62", "vaste opslaginrichtingen, fietsparkeersystemen"],
  ["97.7", "vaste functionele inrichtingen"],
  ["97.70", "vaste functionele inrichtingen, algemeen (verzamelniveau)"],
  ["97.8", "terrein gerelateerde kunst"],
  ["97.80", "terrein gerelateerde kunst, algemeen (verzamelniveau)"],
  ["97.81", "terrein gerelateerde kunst, standaard"],
  ["97.82", "terrein gerelateerde kunst, bijzonder"],
  ["97.9", "hoger niet genoemde subelementen"],
  ["98.0", "containerelementen"],
  ["98.1", "losse verkeersinrichtingen"],
  ["98.10", "losse verkeersinrichtingen, algemeen (verzamelniveau)"],
  ["98.11", "losse verkeersinrichtingen, mobiele wegafsluitingen"],
  ["98.12", "losse verkeersinrichtingen, tijdelijke wegbewijzeringen"],
  ["98.13", "losse verkeersinrichtingen, tijdelijke wegafzettingen"],
  ["98.2", "losse gebruikersinrichtingen"],
  ["98.20", "losse gebruikersinrichtingen, algemeen (verzamelniveau)"],
  ["98.5", "losse onderhoudsinrichtingen"],
  ["98.50", "losse onderhoudsinrichtingen, algemeen (verzamelniveau)"],
  ["98.51", "losse onderhoudsinrichtingen, grasmaaiers"],
  ["98.52", "losse onderhoudsinrichtingen, veegmachines"],
  ["98.53", "losse onderhoudsinrichtingen, klein tuingereedschap"],
  ["98.6", "losse opslaginrichtingen"],
  ["98.60", "losse opslaginrichtingen , algemeen (verzamelniveau)"],
  ["98.61", "losse opslaginrichtingen , afvalbakken en containers"],
  ["98.7", "losse functionele inrichtingen"],
  ["98.70", "losse functionele inrichtingen, algemeen (verzamelniveau)"],
  ["98.71", "losse functionele inrichtingen, standaard"],
  ["98.72", "losse functionele inrichtingen, bijzonder"],
  ["98.8", "losse kunst"],
  ["98.80", "losse kunst, algemeen (verzamelniveau)"],
  ["98.81", "losse kunst, standaard"],
  ["98.82", "losse kunst, bijzonder"],
  ["98.9", "hoger niet genoemde subelementen"],
];
